import React from 'react';
import PropTypes from 'prop-types';

import proxyFormOperations from '@shared/hocs/ProxyFormOperations';
import Types from '@shared/classes/types';

import KeyPressInterceptor from '@shared/components/KeyPressInterceptor';

function Version2ProxyForm({
    targetURL,
    hasError,
    onChangeTargetURL,
    handleSubmitURL,
    placeholder,
    startLabel,
    errorLabel,
}) {
    return (
        <div className={`proxy-form${hasError ? ' proxy-form--error' : ''}`}>
            <label className="sr-only" htmlFor="proxy-url">{placeholder}</label>
            <input
                id="proxy-url"
                name="proxy-url"
                type="text"
                autoCapitalize="none"
                spellCheck="false"
                placeholder={placeholder}
                value={targetURL}
                onChange={onChangeTargetURL}
            />
            <button type="button" onClick={handleSubmitURL}>{startLabel}<span className="arrow">-&gt;</span></button>
            <KeyPressInterceptor
                keyCodes={Types.KEY_CODES.ENTER}
                onKeyPressed={handleSubmitURL}
            />
            {hasError && <p className="proxy-form__error">{errorLabel}</p>}
        </div>
    );
}

Version2ProxyForm.propTypes = {
    targetURL: PropTypes.string,
    hasError: PropTypes.bool,
    onChangeTargetURL: PropTypes.func,
    handleSubmitURL: PropTypes.func,
    placeholder: PropTypes.string.isRequired,
    startLabel: PropTypes.string.isRequired,
    errorLabel: PropTypes.string.isRequired,
};

export default proxyFormOperations(Version2ProxyForm);
